module.exports = __webpack_public_path__ + "static/media/Blokes-words-transparent-small.5d22d7fc.png";